import { useEffect } from "react";
import { useRouter } from "next/router";
import NutritionPackagesPage from "@/containers/NutritionPackagesPage";
import { renderMetaData } from "@/utils";
//Redux
import { wrapper } from "@/redux/Store";
import * as dashboardActions from "@/redux/DashboardReducer";
import * as actions from "@/redux/HealthProgramV1Reducer";

import { useAppDispatch } from "@/hooks";

const NutritionPackagePage = () => {
  const router = useRouter();
  const slug = router.query?.slug?.[0];

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      actions.getHealthLandingPageV1({
        slug: slug ? `nutrition-packages-${slug}` : "nutrition-packages",
      })
    );
  }, [dispatch, slug]);

  const detailPageSlug = slug?.toUpperCase().split("-").join(" ");

  const h1Text = `${slug ? detailPageSlug + " " : ""}Nutrition packages`;

  const metaData = {
    siteName: "Shyft",
    siteURL: `https://www.betheshyft.com/nutrition-packages${
      slug ? "/" + slug : ""
    }`,
    title: `${
      slug ? detailPageSlug + " " : ""
    }Nutrition consultations Online by experienced nutritionists | Shyft Health`,
    description:
      "Consult the best nutritionist online and get the personalized diet plan according to your health condition. Sign up for pre consultation and pay now to book a suitable package.",
    thumbnail: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
    h1Text,
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <main>
        <NutritionPackagesPage h1Text={h1Text} />
      </main>
    </>
  );
};

export default NutritionPackagePage;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ query }) => {
      const slug = query?.slug?.[0];
      await store.dispatch(
        dashboardActions.getRibbonData({ pathname: "nutrition-packages" })
      );
      const res = await store.dispatch(
        actions.getHealthLandingPageV1({
          slug: slug ? `nutrition-packages-${slug}` : "nutrition-packages",
        })
      );
      if (!res?.payload) {
        return {
          notFound: true,
        };
      }
    }
);
